import { constantTree } from "../../../core/events/ConstantTree";

export const changeDateTree = constantTree({
    ChangeDate: {
        Init: "",
        PassengerOutboundCheck: "",
        MainOutboundCheck: "",
        MainInboundCheck: "",
        BackToBookingClick: "",
        ChangeDateRedirectClick: "",
        ChangeDateContinueClick: "",
        DateSelector: {
            Change: ""
        },
        UpdateSelectedRange: "",
        UpdateSelectedChangeDate: "",
        UpdateInboundSelectedChangeDate: ""
    }
})